const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_623",
  "data-name": "Rectangle 623",
  width: 71.443,
  height: 66.507,
  fill: "#e3021c"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_498",
  "data-name": "Group 498",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_164",
  "data-name": "Path 164",
  d: "M68.98,44.338H54.2V12.316a3.724,3.724,0,0,0-7.39-.628l-14.9,12.661a2.21,2.21,0,0,0,.124-.764V2.463A2.463,2.463,0,0,0,29.568,0H2.473A2.463,2.463,0,0,0,.01,2.463V19.706a2.463,2.463,0,0,0,2.463,2.463h22.81l1.97,2.463h-13.7a1.232,1.232,0,0,0-1.232,1.232v1.453A3.7,3.7,0,0,0,7.4,30.79v3.695a3.7,3.7,0,0,0,4.926,3.474v1.453a1.232,1.232,0,0,0,1.232,1.232H19.1v4.471a3.068,3.068,0,0,0-1.65.64l-2.18,1.75H7.4a3.7,3.7,0,1,0-7.39.529V62.812a3.695,3.695,0,1,0,7.39,0h4.926c.678,0,.7,0,.887.395,0,.123.124.246.221.419a3.167,3.167,0,0,0,2.587,1.4h8.4A3.62,3.62,0,0,0,28,62.036l1.564-7.5a5.587,5.587,0,0,0,.221-3.941,5.516,5.516,0,0,0-1.12-1.921l-.505-1.5a3.018,3.018,0,0,0-1.638-1.811V40.643h5.087l7.808,6.626V64.044a2.463,2.463,0,0,0,2.463,2.463h27.1a2.463,2.463,0,0,0,2.463-2.463V46.8a2.463,2.463,0,0,0-2.463-2.463M12.326,34.485a1.232,1.232,0,1,1-2.463,0V30.79a1.232,1.232,0,1,1,2.463,0ZM4.936,48.722v14.09a1.232,1.232,0,0,1-2.463,0V48.033a1.232,1.232,0,1,1,2.463,0ZM27.2,20.629a2.463,2.463,0,0,0-1.921-.924H2.473V2.463h27.1V23.585Zm-.517,29.559a2.985,2.985,0,0,1,.726,1.232,3.163,3.163,0,0,1-.172,2.266,1.1,1.1,0,0,0-.087.284l-1.54,7.611a1.231,1.231,0,0,1-1.157.985H16.021a.691.691,0,0,1-.542-.259l-.111-.209a2.957,2.957,0,0,0-3.042-1.749H7.4V49.954h8.3a1.229,1.229,0,0,0,.763-.271l2.525-2.02a.627.627,0,0,1,.357-.123h5.9a.59.59,0,0,1,.554.394l.579,1.774a1.322,1.322,0,0,0,.308.492Zm-5.124-9.545h2.463v4.311H21.563ZM30.8,38.18H14.789V27.1H30.8ZM49.274,12.316a1.22,1.22,0,0,1,2.106-.85,1.145,1.145,0,0,1,.357.85V44.338H49.274Zm-8.2,28.327a2.464,2.464,0,0,0-1.65,2.279v1.12l-6.158-5.2V26.431L46.811,14.977V44.338H46.17l-2.365-2.955a2.462,2.462,0,0,0-2.734-.739m.813,23.4V42.922l2.365,2.955a2.463,2.463,0,0,0,1.921.924H68.98V64.044Z",
  transform: "translate(0)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_165",
  "data-name": "Path 165",
  d: "M47.29,30H31.279a1.232,1.232,0,0,0,0,2.463H47.29a1.232,1.232,0,0,0,0-2.463",
  transform: "translate(-23.879 -23.842)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_166",
  "data-name": "Path 166",
  d: "M47.29,60H31.279a1.232,1.232,0,1,0,0,2.463H47.29a1.232,1.232,0,0,0,0-2.463",
  transform: "translate(-23.879 -47.684)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_167",
  "data-name": "Path 167",
  d: "M245.289,252H229.279a1.232,1.232,0,0,0,0,2.463h16.011a1.232,1.232,0,1,0,0-2.463",
  transform: "translate(-181.236 -200.272)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M245.289,282H229.279a1.232,1.232,0,0,0,0,2.463h16.011a1.232,1.232,0,1,0,0-2.463",
  transform: "translate(-181.236 -224.114)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M277.279,143.084a1.232,1.232,0,0,0,1.232-1.232v-8.621a1.232,1.232,0,1,0-2.463,0v8.621a1.232,1.232,0,0,0,1.232,1.232",
  transform: "translate(-219.383 -104.905)",
  fill: "#e3021c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_170",
  "data-name": "Path 170",
  d: "M301.279,134.243a1.232,1.232,0,0,0,1.232-1.232V118.232a1.232,1.232,0,1,0-2.463,0v14.779a1.232,1.232,0,0,0,1.232,1.232",
  transform: "translate(-238.457 -92.984)",
  fill: "#e3021c"
}));
function SvgIconMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_499",
    "data-name": "Group 499",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.443,
    height: 66.507,
    viewBox: "0 0 71.443 66.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMegaphone);
export default __webpack_public_path__ + "static/media/icon-megaphone.b639b07f.svg";
export { ForwardRef as ReactComponent };